<template>
  <div class="name-input">
    <label for="first">First Name</label>
    <input
      id="first"
      type="text"
      v-model="name.first"
      @input="$emit('input',{value: name})"
      required
    />
    <label for="last">Last Name</label>
    <input
      id="last"
      type="text"
      v-model="name.last"
      @input="$emit('input',{value: name})"
      required
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: {
        first: null,
        last: null
      }
    }
  },
  watch: {
    value (newValue) {
      this.name = newValue
    }
  },
  computed: {
    value () {
      return this.$store.state.userData[this.dataKey]
    }
  },
  props: ['options', 'data-key', 'required']
}
</script>
